<template>
  <div style="width: 100%">
    <div :id="id" :style="{ width: '100%', height: '500px' }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: "line-statistics-modular",
  data () {
    return {}
  },
  props: {
    title: {
      type: String
    },
    id: {
      type: String,
    },
    month: {
      type: Array,
    },
   
    total: {
      type: Array,
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.drawLine();
  },
  methods: {
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ['line', 'bar'] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        legend: {
          data: ['通知公告', '组织动态', '活动管理', '服务申请'],
          // textStyle: {
          //   'color': '#fff'
          // }
        },
        xAxis: [
          {
            type: 'category',
            data: this.month,
            axisPointer: {
              type: 'shadow'
            },
            nameTextStyle: {
              'color': '#fff'
            },
            axisLabel:{
              interval:0,
              rotate:40,
            }
          }
        ],
        yAxis: {
          type: 'value',
            minInterval: 1,
        },
        series: this.total
      });
    }
  },
  watch: {
    total () {
      this.drawLine();
    }
  }
}
</script>

<style scoped lang="scss">
.title-warpper {
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 16px;

  .title-text {
    color: #667fa0;

    i {
      font-size: 20px;
      margin-right: 10px;
    }
  }
  .wecome {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    span {
      color: #0d7fd7;
    }
  }
}
</style>